<template>
    <div class="addProp-box">
        <h3 class="subtitle">{{$t('addProperty.Layout')}}</h3>
        <el-form
            :label-position="'left'"
            label-width="108px"
            ref="formProp3"
            :rules="formRule3"
            :model="formProp3"
        >
            <el-form-item class="layout-fx" :label="$t('addProperty.bedrooms')">
                <el-input-number
                    v-model="formProp3.bedrooms"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.bedrooms')"
                ></el-input-number>
            </el-form-item>
            <el-form-item class="layout-fx" :label="$t('addProperty.bathrooms')">
                <el-input-number
                    v-model="formProp3.bathrooms"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.bathrooms')"
                ></el-input-number>
            </el-form-item>
            <el-form-item class="layout-fx" :label="$t('addProperty.livingRooms')">
                <el-input-number
                    v-model="formProp3.livingRooms"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.livingRooms')"
                ></el-input-number>
            </el-form-item>
            <el-form-item class="layout-fx" :label="$t('addProperty.kitchens')">
                <el-input-number
                    v-model="formProp3.kitchens"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.kitchens')"
                ></el-input-number>
            </el-form-item>
            <el-form-item class="layout-fx" :label="$t('addProperty.parkingSpaces')">
                <el-input-number
                    v-model="formProp3.parkingSpaces"
                    :min="0"
                    :max="10"
                    :label="$t('addProperty.parkingSpaces')"
                ></el-input-number>
            </el-form-item>
            <h3 class="subtitle pt30mb30 border-top">{{$t('addProperty.details')}}</h3>

            <!-- <el-form-item class="specific-label-top"> -->
            <el-row :gutter="16" class="type-card">
                <el-radio-group v-model="formProp3.areaUnit">
                    <el-col :xs="12">
                        <el-radio label="MT" border>{{$t('addProperty.SQM')}}</el-radio>
                    </el-col>
                    <el-col :xs="12">
                        <el-radio label="FT" border>{{$t('addProperty.SQFT')}}</el-radio>
                    </el-col>
                </el-radio-group>
            </el-row>

            <el-row :gutter="8">
                <el-col :sm="12" :xs="24">
                    <el-form-item
                        class="p-relative"
                        :label="$t('addProperty.InternalArea')"
                        prop="areaInternal"
                    >
                        <numeric-input type="number" v-model="formProp3.areaInternal"></numeric-input>
                        <span
                            class="append placeholderPend"
                            v-if="formProp3.areaUnit == 'MT'"
                        >{{$t('addProperty.SQM')}}</span>
                        <span
                            class="append placeholderPend"
                            v-if="formProp3.areaUnit == 'FT'"
                        >{{$t('addProperty.SQFT')}}</span>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :xs="24" v-if="collection.propertyType != '3' ">
                    <el-form-item class="p-relative" :label="$t('addProperty.LotArea')">
                        <numeric-input type="number" v-model="formProp3.areaLot"></numeric-input>
                        <span
                            class="append placeholderPend"
                            v-if="formProp3.areaUnit == 'MT'"
                        >{{$t('addProperty.SQM')}}</span>
                        <span
                            class="append placeholderPend"
                            v-if="formProp3.areaUnit == 'FT'"
                        >{{$t('addProperty.SQFT')}}</span>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :xs="24" v-if="collection.propertyType == '3' ">
                    <el-form-item class="p-relative" :label="$t('addProperty.ExternalArea')">
                        <numeric-input type="number" v-model="formProp3.areaLot"></numeric-input>
                        <span
                            class="append placeholderPend"
                            v-if="formProp3.areaUnit == 'MT'"
                        >{{$t('addProperty.SQM')}}</span>
                        <span
                            class="append placeholderPend"
                            v-if="formProp3.areaUnit == 'FT'"
                        >{{$t('addProperty.SQFT')}}</span>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :xs="24" v-if="collection.propertyType == '3'">
                    <el-form-item class="p-relative" :label="$t('addProperty.FloorOptional')">
                        <numeric-input type="number" v-model="formProp3.floor"></numeric-input>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :xs="24" v-if="collection.propertyType == '3'">
                    <el-form-item class="p-relative" :label="$t('addProperty.TotalFloor')">
                        <numeric-input type="number" v-model="formProp3.totalFloorsBuilding"></numeric-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-button type="primary" @click="submit">{{$t('addProperty.Submit')}}</el-button>
        </el-form>
    </div>
</template>
<script>
import { Message } from "element-ui";
import numericInput from "@/components/common/numeric-input.vue";
export default {
    name: "addProp3",
    props: ["collection"],
    data() {
        const $t = this.$t.bind(this);
        return {
            formRule3: {
                areaInternal: {
                    required: true,
                    message: $t("addProperty.internalError"),
                    trigger: ["blur", "change"]
                }
            },
            formProp3: {
                bedrooms: "1",
                bathrooms: "1",
                livingRooms: "1",
                kitchens: "1",
                parkingSpaces: "0",
                areaUnit: "MT",
                areaInternal: "",
                areaLot: "0",
                floor: "",
                totalFloorsBuilding: ""
            }
        };
    },

    methods: {
        submit() {
            this.$refs["formProp3"].validate(valid => {
                if (!valid) {
                    this.triggerMessage("error", {
                        message: this.$t("addProperty.fieldsError")
                    });
                } else {
                    let floor_q = this.checkFloor();

                    if (floor_q == "2") {
                        this.formProp3.floor = "";
                        this.formProp3.totalFloorsBuilding = "";
                    }
                    if (floor_q != "0") {
                        this.formProp3.parkingSpaces = this.formProp3.parkingSpaces.toString();
                        this.$emit("goToStep", {
                            step: 4,
                            form: this.formProp3
                        });
                    }
                }
            });
        },

        checkFloor() {
            if (this.formProp3.floor && this.formProp3.totalFloorsBuilding) {
                if (this.formProp3.floor > this.formProp3.totalFloorsBuilding) {
                    this.triggerMessage("error", {
                        message: this.$t("addProperty.floorBiggerTotal")
                    });
                    return "0";
                } else {
                    return "1";
                }
            } else {
                return "2";
            }
        },

        triggerMessage(type, options) {
            options.duration = 6000;
            return Message[type](options);
        }
    },

    components: {
        numericInput
    },

    watch: {}
};
</script>
<style lang="scss" scoped>
.addProp-box {
    .subtitle {
        font-family: GothamMedium;
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
        color: #2e384d;
    }
    .border-top {
        border-top: 1px solid #ebebeb;
    }
    .pt30mb30 {
        padding-top: 30px;
        margin-bottom: 30px;
        margin-top: 0;
    }
    .el-button {
        margin: 30px 0;
    }
    .type-card {
        margin-bottom: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account/addProp3.vue